import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useFtblCurrentClub } from 'shared/hooks/useFtblCurrentClub';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { ProfileTitleSubtitle } from '../styles';

type FtblProfileClubSubtitleProps = {
  accountId?: string;
};

const ClubLink = styled(Link)`
  font-weight: 600;
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const FtblProfileClubSubtitle: FC<FtblProfileClubSubtitleProps> = ({ accountId }) => {
  const { t, i18n } = useTranslation();
  const { clubName, clubTeamId } = useFtblCurrentClub(accountId, i18n.language);

  if (!clubName || !clubTeamId) return null;

  return (
    <ProfileTitleSubtitle>
      {t('ftbl.profile_page.club_member')}{' '}
      <ClubLink to={CreateLinkTo.team(clubTeamId)}>{clubName}</ClubLink>
    </ProfileTitleSubtitle>
  );
};
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useFtblCurrentClub } from 'shared/hooks/useFtblCurrentClub';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { ProfileTitleSubtitle } from '../styles';

type FtblProfileClubSubtitleProps = {
  accountId?: string;
};

const ClubLink = styled(Link)`
  font-weight: 600;
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const FtblProfileClubSubtitle: FC<FtblProfileClubSubtitleProps> = ({ accountId }) => {
  const { t, i18n } = useTranslation();
  const { clubName, clubTeamId } = useFtblCurrentClub(accountId, i18n.language);

  if (!clubName || !clubTeamId) return null;

  return (
    <ProfileTitleSubtitle>
      {t('ftbl.profile_page.club_member')}{' '}
      <ClubLink to={CreateLinkTo.team(clubTeamId)}>{clubName}</ClubLink>
    </ProfileTitleSubtitle>
  );
};
